module.exports = __webpack_public_path__ + "static/img/result-bg.fc51fec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/limit-activity/result-bg.png
// module id = ruB0
// module chunks = 216